'use client';

// import cn from 'classnames';
// import { useFormik } from 'formik';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';

// import Button from '@/components/Button';
import FooterCheckout from '@/components/FooterCheckout';
import FooterLinks from '@/components/FooterLinks';
// import Input from '@/components/Input';
import Loader from '@/components/Loader';
// import { useProductGallery } from '@/contexts/GalleryModalContext';
// import { useUserAgent } from '@/contexts/UserAgentContext';
// import { useAddNewsletter } from '@/utils/hooks/useAddNewsletter';
// import { newsletterValidationSchema } from '@/utils/validation';
import blik from 'public/icons/blik.svg';
import mastercard from 'public/icons/mastercard.svg';
import visa from 'public/icons/visa.svg';
import patynaLogo from 'public/images/patyna_logo_light.svg';

import styles from './styles.module.scss';
import { FooterProps } from './types';

const FooterWrapper = ({ data }: FooterProps) => {
  const [isCheckoutMenu, setIsCheckoutMenu] = useState(true);
  // const { isGalleryOpen } = useProductGallery();
  // const { isMacOS } = useUserAgent();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  // const { isLoading, isSuccess, mutate, isError } = useAddNewsletter();
  // const {
  //   handleSubmit: newsletterHandleSubmit,
  //   handleChange: handleNewsletterChange,
  //   values: newsletterValues,
  // } = useFormik({
  //   initialValues: {
  //     email: '',
  //   },
  //   validationSchema: newsletterValidationSchema,
  //   onSubmit: async values => {
  //     mutate(values);
  //   },
  // });

  const attr = data.attributes;
  const {
    OpisStrony: SiteDescription,
    DlaKupujacych: { Linki: ForBuyers },
    DlaSprzedajacych: { Linki: ForSellers },
    Informacje: { Linki: Information },
    Kategorie: { Linki: Categories },
    MediaSpolecznosciowe: Socials,
    Kontakt: { LinkiKontaktowe: ContactLinks },
    // OpisNewslettera: NewsletterDesc,
  } = attr;

  useEffect(() => {
    if (
      pathname?.includes('/zamowienie') ||
      pathname?.includes('/podsumowanie')
    ) {
      setIsCheckoutMenu(true);
    } else if (pathname?.includes('/logowanie')) {
      const fromCartParam = searchParams?.get('fromCart');

      if (fromCartParam === 'true') {
        setIsCheckoutMenu(true);
      }
    } else {
      setIsCheckoutMenu(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  if (!data) {
    return <Loader />;
  }

  return isCheckoutMenu ? (
    <FooterCheckout />
  ) : (
    <footer className={styles.container}>
      <div className={styles.top}>
        <div className={styles.footerNav}>
          <div className={styles.logoWrapper}>
            <Link href="/">
              <Image
                src={patynaLogo}
                alt="Patyna - sklep z meblami i dekoracjami vintage"
                width={95}
              />
            </Link>
            <p>Wybierz vintage!</p>
          </div>
          <div className={styles.colWrapper}>
            <div className={styles.col1}>
              <FooterLinks label="Dla kupujących" data={ForBuyers} />
              <FooterLinks label="Dla sprzedających" data={ForSellers} />
            </div>
            <div className={styles.col2}>
              <FooterLinks label="Informacje" data={Information} />
            </div>
            <div className={styles.col3}>
              <FooterLinks label="Kategorie" data={Categories} />
            </div>
            <div className={styles.col4}>
              <FooterLinks label="Skontaktuj się z nami" data={ContactLinks} />
              <div className={styles.socials}>
                <p className={styles.label}>Obserwuj nas</p>
                <div className={styles.socialsWrapper}>
                  {Socials &&
                    Socials.map(social => {
                      const { URL, Ikona: Icon, id } = social;
                      return (
                        <a href={URL} key={id} target="_blank">
                          <Image
                            src={Icon.data.attributes.url}
                            width={16}
                            height={16}
                            alt={
                              social.TekstAlternatywny
                                ? social.TekstAlternatywny
                                : Icon.data.attributes.name
                            }
                          />
                        </a>
                      );
                    })}
                </div>
              </div>
            </div>
            {/* <form
              className={cn(styles.newsletter, {
                [styles.hidden]: isGalleryOpen === true,
              })}
              onSubmit={newsletterHandleSubmit}
            >
              <p
                className={cn(styles.label, {
                  [styles.avenirFont]: isMacOS,
                })}
              >
                Newsletter
              </p>
              <p className={styles.text}>{NewsletterDesc}</p>
              <div className={styles.newsletterInputWrapper}>
                <Input
                  type="text"
                  name="email"
                  placeholder="Wpisz adres e-mail"
                  isDarkBgc
                  isBorderNone
                  onChange={handleNewsletterChange}
                  value={newsletterValues.email}
                >
                  <Button
                    type="submit"
                    className={styles.newsletterButton}
                    disabled={isSuccess || isLoading}
                  >
                    Zapisz
                  </Button>
                </Input>
              </div>
              {isError && (
                <p className={styles.error}>
                  Wystąpił błąd. Spróbuj ponownie póżniej
                </p>
              )}
              {isSuccess && (
                <p className={styles.success}>Zapisano do newslettera</p>
              )}
            </form> */}
          </div>
        </div>
      </div>
      <div className={styles.bottom}>
        <ReactMarkdown className={styles.description}>
          {SiteDescription}
        </ReactMarkdown>
        <div className={styles.bottomRow}>
          <div className={styles.copyrights}>
            <span>@{new Date().getFullYear()} Patyna</span> <div>|</div>{' '}
            <span>
              Realizacja:{' '}
              <Link
                href="https://digispot.pl/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Digispot.pl
              </Link>
            </span>
          </div>
          <div className={styles.paymentMethods}>
            <Image src={visa} height={18} alt="Visa" />
            <Image src={mastercard} height={24} alt="Mastercard" />
            <Image src={blik} height={24} alt="BLIK" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterWrapper;
